import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { NavigationGroup, NavigationRoute } from ".";

import ReadIcon from "@assets/SVGIcons/ReadIcon.web";
import MyGradebookIcon from "@assets/SVGIcons/MyGradebookIcon.web";
import MyPathIcon from "@assets/SVGIcons/MyPathIcon.web";

const PendingExtensions = lazy(() => import("@components/pages/registrarWorkSpace/extensions/PendingExtensions"));

const StudentProfile = lazy(() => import("@components/pages/registrarWorkSpace/students/@studentProfile/StudentProfile"));
const AnalyticsProgressTab = lazy(() => import("@components/pages/registrarWorkSpace/students/@studentProfile/analyticsTabs/AnalyticsProgressTab"));
const AnalyticsPerformanceTab = lazy(() => import("@components/pages/registrarWorkSpace/students/@studentProfile/analyticsTabs/AnalyticsPerformanceTab"));
const AnalyticsTimeSpentTab = lazy(() => import("@components/pages/registrarWorkSpace/students/@studentProfile/analyticsTabs/AnalyticsTimeSpentTab"));
const RegistrarStudents = lazy(() => import("@components/pages/registrarWorkSpace/students/RegistrarStudents"));
const RegistrarProfile = lazy(() => import("@components/pages/registrarWorkSpace/profile/RegistrarProfile"));

const GradeBooks = lazy(() => import("@components/pages/registrarWorkSpace/gradebooks/GradeBooks"));
const GradeBookDetails = lazy(() => import("@components/pages/registrarWorkSpace/gradebooks/GradeBookDetails"));
const GradeBookGradesTab = lazy(() => import("@components/pages/registrarWorkSpace/gradebooks/tabs/GradeBookGradesTab"));
const GradeBookAttendancesTab = lazy(() => import("@components/pages/registrarWorkSpace/gradebooks/tabs/GradeBookAttendanceTab"));

export const registrarRoutes: NavigationRoute[] = [
  {
    path: "students/:student_id",
    label: "students",
    component: <StudentProfile />,
    children: [
      {
        index: true,
        component: <Navigate to="progress" />,
      },
      {
        path: "progress",
        component: <AnalyticsProgressTab />,
      },
      {
        path: "performance",
        component: <AnalyticsPerformanceTab />,
      },
      {
        path: "time-spent",
        component: <AnalyticsTimeSpentTab />,
      },
    ],
  },
  {
    path: "profile",
    label: "profile",
    component: <RegistrarProfile />,
  },
  {
    label: "Grade Book Details",
    path: "gradebooks/:student_id/:grade_level_id",
    component: <GradeBookDetails />,
    children: [
      {
        index: true,
        component: <GradeBookGradesTab />,
      },
      {
        path: "attendance-behavior",
        component: <GradeBookAttendancesTab />,
      }
    ]
  },
];

export const registrarNavigations: NavigationGroup[] = [
  {
    title: "Manage Hub",
    routes: [
      {
        path: "students",
        label: "students",
        component: <RegistrarStudents />,
        icon: <ReadIcon fontSize="medium" />,
      },
      {
        path: "gradebooks",
        label: "grade books",
        component: <GradeBooks />,
        icon: <MyGradebookIcon fontSize="medium" />,
      },
      {
        path: "extensions",
        label: "extensions",
        component: <PendingExtensions />,
        icon: <MyPathIcon fontSize="medium" />,
      },
    ],
  },
];

export default registrarNavigations;
